// extracted by mini-css-extract-plugin
module.exports = {"item":"SummaryPanel_item__2Og5q","sidebar":"SummaryPanel_sidebar__1-Xrp","summaryPanelInfoIcon":"SummaryPanel_summaryPanelInfoIcon__3EKiI"};